module.exports = __webpack_public_path__ + "img/sec2_24.6f9fb98f.jpg";